import { Component, HostListener, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ResponsiveService } from '../../services/responsive.service';
import { CardModule } from '../../models/card/card-module';
import { FormModule } from '../../models/form/form-module';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CardModule, FormModule],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('backoffice');
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.responsiveS.width = event.target.innerWidth;
  }
  constructor(public responsiveS: ResponsiveService) {
    this.responsiveS.width = window.innerWidth;
  }
}
